"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleWithOverrides = exports.RouteTransitionProvider = exports.createTheme = exports.getProductName = exports.themes = exports.scrollbars = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styles = require("@material-ui/core/styles");

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _Logo = _interopRequireDefault(require("../Logo"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Most of the logos are text-only, so make them a consistent height
// This is set manually on logos that are more complex
// Any logo that is more than 1em tall should set a margin-top such that the text part of the logo is centered
var logoStyle = {
  maxHeight: "1em"
};
var scrollbars = {
  main: {
    // Enable overflow
    overflow: "auto",
    // Webkit/Blink (Chrome/Safari)
    overflowX: "overlay",
    overflowY: "overlay",
    "&::-webkit-scrollbar": {
      width: "0.5rem"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0, 0, 0, 0.25)"
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.18)"
    },
    "&::-webkit-scrollbar-thumb:active": {
      backgroundColor: "rgba(0, 0, 0, 0.21)"
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgba(0, 0, 0, 0.05)"
    },
    // Firefox
    scrollbarColor: "rgba(0, 0, 0, 0.25) rgba(0, 0, 0, 0.05)",
    scrollbarWidth: "thin"
  }
};
exports.scrollbars = scrollbars;
var defaultTheme = {
  name: "CivicPlus",
  logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
    product: "CivicPlus",
    white: true,
    style: {
      maxHeight: "1.22em",
      marginTop: ".22em"
    }
  }),
  palette: {
    contrastThreshold: 4.5,
    primary: {
      main: "#CC0020"
    },
    secondary: {
      main: "#383838"
    },
    background: {
      blurred: "rgba(255,255,255,.75)",
      default: "#eee"
    },
    text: {
      secondary: "rgba(0,0,0,.6)"
    }
  }
};

var makeActionColorFromHex = function makeActionColorFromHex(hex) {
  var _hex$match$map = hex.match(/\w\w/g).map(function (x) {
    return parseInt(x, 16);
  }),
      _hex$match$map2 = (0, _slicedToArray2.default)(_hex$match$map, 3),
      r = _hex$match$map2[0],
      g = _hex$match$map2[1],
      b = _hex$match$map2[2];

  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",.07)");
};

var themes = {
  default: defaultTheme,
  clerk: {
    name: "CivicClerk",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "CivicClerk",
      white: true,
      style: logoStyle
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#7958E8"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  },
  engageCentral: {
    name: "CivicEngage Central",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "CivicEngage Central",
      white: true,
      style: logoStyle
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#006CF6"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  },
  engageEvolve: {
    name: "CivicEngage Evolve",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "CivicEngage Evolve",
      white: true,
      style: logoStyle
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#006CF6"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  },
  hr: {
    name: "CivicHR",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "CivicHR",
      white: true,
      style: logoStyle
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#007EBC"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  },
  optimize: {
    name: "CivicOptimize",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "CivicOptimize",
      white: true,
      style: logoStyle
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#008672"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  },
  ready: {
    name: "CivicReady",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "CivicReady",
      white: true,
      style: {
        maxHeight: "1.61em",
        marginTop: ".61em"
      }
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#BE4B00"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  },
  rec: {
    name: "CivicRec",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "CivicRec",
      white: true,
      style: logoStyle
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#408100"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  },
  service: {
    name: "CivicService",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "CivicService",
      white: true,
      style: {
        maxHeight: "1.5em",
        marginTop: ".5em"
      }
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#737373"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  },
  scf: {
    name: "SeeClickFix",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "SeeClickFix",
      white: true,
      style: {
        maxHeight: "1.46em",
        marginTop: ".46em"
      }
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#0099CC"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  },
  preamble: {
    name: "Preamble",
    logo: /*#__PURE__*/_react.default.createElement(_Logo.default, {
      product: "Preamble",
      white: true,
      style: {
        maxHeight: "1.46em",
        marginTop: ".46em"
      }
    }),
    palette: _objectSpread(_objectSpread({}, defaultTheme.palette), {}, {
      primary: {
        main: "#3A7470"
      },
      secondary: {
        main: defaultTheme.palette.secondary.main
      }
    })
  }
}; // Deprecated, TODO: Remove in future version as breaking change

exports.themes = themes;
themes.engage = themes.engageCentral;
themes.engage6 = themes.engageEvolve;

var getProductName = function getProductName(key) {
  if (key in themes) return themes[key].name;
  return "Unknown product";
};

exports.getProductName = getProductName;

var createTheme = function createTheme(product, primaryHex, title) {
  var themePalette = product in themes ? JSON.parse(JSON.stringify(themes[product].palette)) : JSON.parse(JSON.stringify(themes.default.palette));

  if (product === "engage" || product === "engage6") {
    // eslint-disable-next-line no-console
    console.warn("Deprecated theme used. Switch to either engageEvolve or engageCentral.");
  }

  if (typeof primaryHex !== "undefined" && primaryHex !== "") {
    themePalette.primary.main = primaryHex;
  }

  var actionColor = makeActionColorFromHex(themePalette.primary.main);
  themePalette.action = {
    selected: actionColor,
    hover: actionColor
  };
  return (0, _styles.createMuiTheme)({
    palette: themePalette,
    typography: {
      fontFamily: "'Lato', 'Helvetica', 'Arial', sans-serif",
      useNextVariants: true,
      title: {
        color: themePalette.primary.main,
        fontSize: "2rem",
        fontWeight: "300"
      },
      button: {
        fontSize: ".75rem",
        letterSpacing: 1,
        wordBreak: "break-word"
      }
    },
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: themePalette.primary.main
        }
      },
      MuiPickersModal: {
        dialogRoot: {
          borderRadius: 0
        }
      },
      MuiInputBase: {
        input: {
          height: "auto"
        }
      }
    },
    scrollbars: scrollbars,
    title: title
  });
};

exports.createTheme = createTheme;

var RouteTransitionProvider = function RouteTransitionProvider(childComponent) {
  return /*#__PURE__*/_react.default.createElement(_Fade.default, {
    in: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "prmbl-transition-provider",
    style: {
      display: "flex",
      flexGrow: 1,
      flexDirection: "column"
    }
  }, childComponent));
};

exports.RouteTransitionProvider = RouteTransitionProvider;

var StyleWithOverrides = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(StyleWithOverrides, _React$Component);

  var _super = _createSuper(StyleWithOverrides);

  function StyleWithOverrides() {
    var _this;

    (0, _classCallCheck2.default)(this, StyleWithOverrides);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          theme = _this$props.theme,
          overrides = _this$props.overrides,
          children = _this$props.children;

      var renderedTheme = _objectSpread(_objectSpread({}, theme), {}, {
        overrides: _objectSpread(_objectSpread({}, theme.overrides), overrides)
      });

      return /*#__PURE__*/_react.default.createElement(_styles.MuiThemeProvider, {
        theme: renderedTheme
      }, children);
    });
    return _this;
  }

  return StyleWithOverrides;
}(_react.default.Component);

exports.StyleWithOverrides = StyleWithOverrides;
(0, _defineProperty2.default)(StyleWithOverrides, "propTypes", {
  /**
   * The original theme provided by withTheme()
   */
  theme: _propTypes.default.object,

  /**
   * Any additional overrides to apply to the theme
   */
  overrides: _propTypes.default.object,

  /**
   * Node that will receive the new theme
   */
  children: _propTypes.default.node
});